
/* eslint-disable import/prefer-default-export */
const { Menu } = require('./header');

// eslint-disable-next-line import/no-extraneous-dependencies
const { mdmUploadStatus, RFQConstants: { ApprovalStatus } } = require('pando-constants');

export const uploadSampleFileName = {
  port: 'portBulkUpload.xlsx',
  cha: 'chaBulkUpload.xlsx',
  container: 'containersBulkUpload.xlsx',
  transporter: 'transporterBulkUpload.xlsx',
  billdiscount: 'bill_discount_upload.xlsx',
  transportationdb: 'TransportationDb-bulkUpload.xlsx',
  contract: 'rateMatrixBulkUpload.xlsx',
  vehicledetail: 'vehicleAvailabilityBulkUpload.xlsx',
  consignee: 'consigneeBulkUpload.xlsx',
  user: null, // Setting as null to let it download via api
  package_master: 'PackageMasterBulkUpload.xlsx',
  material_package_map: 'PackageMaterialMappingBulkUpload.xlsx',
  material: 'materialBulkUpload.xlsx',
  depot: 'depotsBulkUpload.xlsx',
  gate: 'gatesBulkUpload.xlsx',
  sla: 'slaCharges.xlsx',
  detention: 'detentionBulkUpload.xlsx',
  transshipment: 'transshipmentBulkupload.xlsx',
  dedicatedtruck: 'dedicatedTruckBulkUpload.xlsx',
  transit_management: 'transitBulkUpload.xlsx',
};

export const sampleFileNameMaster = {
  'Port Bulk Upload': 'portBulkUpload.xlsx',
  'Cha Bulk Upload': 'chaBulkUpload.xlsx',
  'Container Bulk Upload': 'containersBulkUpload.xlsx',
  'Transporter Bulk Upload': '', // Setting as '' to let it download via api
  'Billdiscount Bulk Upload': 'bill_discount_upload.xlsx',
  'TransportationDb-bulkUpload': 'TransportationDb-bulkUpload.xlsx',
  'Surge Threshold Bulk Upload': 'surgeThresholdBulkUpload.xlsx',
  'Vehicle Excludes Bulk Upload': 'contractsVehiclesExclude.xlsx',
  'Vehicle Details Bulk Upload': 'vehicleAvailabilityBulkUpload.xlsx',
  'Consignee Bulk Upload': '', // Setting as '' to let it download via api
  'Consignee Weekly Holiday Upload': '', // Setting as '' to let it download via api
  'Consignee Non Working Days Upload': '', // Setting as '' to let it download via api
  'Vehicle Availability': 'vehicleAvailabilityBulkUpload.xlsx',
  'Vehicle ETA': 'vehicleEtaBulkUpload.xlsx',
  'User Bulk Upload': null, // Setting as null to let it download via api
  'Depot Bulk Upload': 'depotsBulkUpload.xlsx',
  'Gate Bulk Upload': '',
  'Rate matrix Bulk Upload': '', // Setting as '' to let it download via api
  'Sla Bulk Upload': 'slaCharges.xlsx',
  'Detention Bulk Upload': '',
  'Associate Material Bulk Upload': 'associatedMaterialBulkUpload.xlsx',
  'BUCC Bulk Upload': 'buccBulkUpload.xlsx',
  'Loading Unloading Bulk Upload': 'loadingUnloadingCharges.xlsx',
  'BDR Bulk Upload': 'baseFuelRateBulkUpload.xlsx',
  'Vendor Depots Bulk Upload': 'vendorBulkUpload.xlsx',
  'Drop Off Charge Bulk Upload': 'extra-drop-off-charges.xlsx',
  'Location Bulk Upload': 'locationBulkUpload.xlsx',
  'Contract TSD Bulk Upload': '', // Setting as '' to let it download via api
  'Transit Bulk Upload': 'transitBulkUpload.xlsx',
  'Material Categories Bulk Upload': 'material-category-bulk-upload.xlsx',
  'Loading/Unloading Bulk Upload': 'loadingUnloadingCharges.xlsx',
  'Dedicated Truck Bulk Upload': 'dedicated-truck-bulk-upload.xlsx',
  'Source Charge Bulk Upload': '', // Setting as '' to let it download via api
  'Material Categories Additional Upload': 'material-category-additional-upload.xlsx',
  'Redirection Master Bulk Upload': 'redirection-master-bulk-upload.xlsx',
  'Budget Bulk Upload': '', // Setting as '' to let it download via api
};
export const menuOptionData = Menu;

export const additionalUploads = {
  port: [{ name: 'Port Bulk Upload', id: 'port', permission: 'import_port' }],
  cha: [{ name: 'Cha Bulk Upload', id: 'cha', permission: 'import_cha' }],
  container: [{ name: 'Container Bulk Upload', id: 'container', permission: 'import_container' }],
  transporter: [{ name: 'Transporter Bulk Upload', id: 'transporter', permission: 'import_transporter' }],
  billdiscount: [{ name: 'Billdiscount Bulk Upload', id: 'bill', permission: 'import_billdiscount' }],
  transportationdb: [{ name: 'Transportation DB Bulk Upload', id: 'transportationdb', permission: 'import_transportationdb' }],
  contract: [{ name: 'Rate matrix Bulk Upload', id: 'rate_matrix', permission: 'import_rate_matrix' }, { name: 'Surge Threshold Bulk Upload', id: 'surge_threshold', permission: 'import_rate_matrix' }, { name: 'Vehicle Excludes Bulk Upload', id: 'vehicle_excludes', permission: 'import_rate_matrix' }],
  vehicledetail: [{ name: 'Vehicle Details', id: 'vehicledetail', permission: 'import_vehicledetail' }, { name: 'Vehicle Availability', id: 'vehicle_availability', permission: 'import_vehicledetail' }, { name: 'Vehicle ETA', id: 'vehicle_eta', permission: 'import_vehicle_eta' }],
  consignee: [
    { name: 'Consignee Bulk Upload', id: 'consignee', permission: 'import_consignee' },
    { name: 'Consignee Additional Details', id: 'consignee_additional_details', is_from_additional_api: true, permission: 'import_consignee' },
    { name: 'Consignee Secondary User Bulk Upload', id: 'consignee_secondary_user', is_from_additional_api: true, permission: 'import_consignee', feature: 'add_consignee_secondary_user' },
    { name: 'Consignee Weekly Holiday Upload', id: 'consignee_weekly_holiday', is_from_additional_api: true, permission: 'import_consignee' , feature: 'consignee_holiday_bulk_upload'},
    { name: 'Consignee Non Working Days Upload', id: 'consignee_non_working_days', is_from_additional_api: true, permission: 'import_consignee', feature: 'consignee_holiday_bulk_upload' }],
  user: [{ name: 'User Bulk Upload', id: 'user', permission: 'import_user' }],
  material: [{ name: 'Material Bulk Upload', id: 'material', permission: 'import_material' }, { name: 'Associate Material Bulk Upload', id: 'associate_material', permission: 'import_material' }, { name: 'User Material Bulk Upload', id: 'user_associate_material_upload', is_from_additional_api: true, permission: 'import_material_user_association' }],
  depot: [{ name: 'Depot Bulk Upload', id: 'depot', permission: 'import_depot' }, { name: 'Gate Bulk Upload', id: 'gate', permission: 'import_gate' }],
  gate: [{ name: 'Gate Bulk Upload', id: 'gate' }],
  sla: [{ name: 'Sla Bulk Upload', id: 'sla', permission: 'import_sla' }],
  detention: [{ name: 'Detention Bulk Upload', id: 'detention', permission: 'import_detention' }],
  bucc: [{ name: 'BUCC Bulk Upload', id: 'bucc', permission: 'import_bucc' }],
  vehicle: [{ name: 'Vehicle Bulk Upload', id: 'vehicle', permission: 'import_vehicle' }],
  loading: [{ name: 'Loading Unloading Bulk Upload', id: 'loading', permission: 'import_loading' }],
  base_fuel_rate: [{ name: 'BFR Bulk Upload', id: 'base_fuel_rate', permission: 'import_bfr' }],
  vendordepots: [{ name: 'Vendor Depots Bulk Upload', id: 'vendordepots' }],
  purchase_order: [{ name: 'Purchase Order Bulk Upload', id: 'purchase_order', is_from_additional_api: false, permission: 'import_purchase_order' }],
  driver: [{ name: 'Driver Details Bulk Upload', id: 'driver', is_from_additional_api: false, permission: 'import_driver' }],
  carton: [{ name: 'Carton Bulk Upload', id: 'carton', is_from_additional_api: false }],
  extra_drop_off_charge: [{ name: 'Drop Off Charge Bulk Upload', id: 'extra_drop_off_charge', permission: 'import_extra_drop_off_charge' }],
  mdmlocation: [{ name: 'Location Bulk Upload', id: 'mdmlocation', permission: 'import_mdmlocation' }],
  destination_charge: [{ name: 'Destination Charge Bulk Upload', id: 'destination_charge', is_from_additional_api: false, permission: 'import_destination_charge' }],
  contracttsd: [{ name: 'Contract TSD Bulk Upload', id: 'share_of_business', permission: 'import_contracttsd' }],
  transit_management: [{ name: 'Transit Bulk Upload', id: 'transit_management', permission: 'import_transit_management' }],
  materialcategory: [{ name: 'Material Categories Bulk Upload', id: 'materialcategory', permission: 'import_materialcategory' },
    { name: 'Material Categories Additional Upload', id: 'material_category_additional', permission: 'import_materialcategory_additional' }],
  redirection: [{ name: 'Redirection Bulk Upload', id: 'redirection', permission: 'import_redirection' }],
  dedicatedtruck: [{ name: 'Dedicated Trucks', id: 'dedicatedtruck', permission: 'import_dedicatedtruck' }],
  source_charge: [{ name: 'Source Charge Bulk Upload', id: 'source_charge', permission: 'import_source_charge' }],
  freight_zone: [{ name: 'Freight Zone Bulk Upload', id: 'freight_zone', permission: 'import_freight_zone' }],
  legal_entity: [{ name: 'Legal Entity Bulk Upload', id: 'legal_entity', permission: 'import_legal_entity' }],
  budget: [{ name: 'Budget Bulk Upload', id: 'budget', permission: 'import_budget', feature: 'logistics_budget' }],
};
export const AttachmentConstants = {
  images: [
    'jpeg',
    'jpg',
    'png',
    'svg',
  ],
  pdf: [
    'pdf',
    'txt',
    'doc',
    'docx',
    'docm',
  ],
  excel: [
    'xls',
    'xlt',
    'xlm',
    'xlsx',
    'xlsm',
    'xltx',
    'xltm',
  ],
  excelMimes: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.template, application/vnd.ms-excel.sheet.macroEnabled.12, application/vnd.ms-excel.template.macroEnabled.12, text/csv',
  maxMbSize: 12, // max mb size per attachment
};

export const mdmUploadPageConstants = {
  MDM_UPLOAD: 'upload',
  MDM_BULK_UPLOAD: 'Bulk Upload',
  MDM_PENDING: 'PENDING',
  MDM_ATTCHMENT: 'attachment',
  MDM_MASTER_SELECTION_VALIDATION: 'Please Select Master',
  MDM_BULK_UPLOAD_FAILED: 'Upload Failed',
  MDM_SECTION_NAME: 'sectionName',
  MDM_OPTION_SELECTION_VALIDATION: 'Please Select Option',
};

export const frontEndStatusMapper = {
  [mdmUploadStatus.UPLOAD_STARTED]: 'MDM_STATUS_UPLOAD_STARTED',
  [mdmUploadStatus.UPLOAD_IN_PROGRESS]: 'MDM_STATUS_UPLOAD_IN_PROGRESS',
  [mdmUploadStatus.VALIDATION_COMPLETED]: 'MDM_STATUS_VALIDATION_COMPLETED',
  [mdmUploadStatus.UPLOAD_DISCARDED]: 'MDM_STATUS_UPLOAD_DISCARDED',
  [mdmUploadStatus.UPLOAD_COMPLETED]: 'MDM_STATUS_UPLOAD_COMPLETED',
  [mdmUploadStatus.APPROVAL_PENDING]: 'MDM_STATUS_APPROVAL_PENDING',
  [mdmUploadStatus.APPROVAL_REJECTED]: 'MDM_STATUS_APPROVAL_REJECTED',
  [mdmUploadStatus.UPLOAD_FAILED]: 'MDM_STATUS_UPLOAD_FAILED',
  [mdmUploadStatus.UPLOAD_PARTIAL_FAILED]: 'MDM_STATUS_UPLOAD_PARTIAL_FAILED',
};

export const frontEndApprovalStatusMapper = {
  [ApprovalStatus.PENDING]: 'MDM_PENDING',
  [ApprovalStatus.ACTIVE]: 'MDM_ACTIVE',
  [ApprovalStatus.APPROVED]: 'MDM_APPROVED',
  [ApprovalStatus.REJECTED]: 'MDM_REJECTED',
};

export const filterOptions = [
  { id: 'validation_completed', name: 'Validated', tlabel: 'MDM_STATUS_VALIDATION_COMPLETED', query: mdmUploadStatus.VALIDATION_COMPLETED, selected: false, cleared: false },
  { id: 'upload_discarded', name: 'Discarded', tlabel: 'MDM_STATUS_UPLOAD_DISCARDED', query: mdmUploadStatus.UPLOAD_DISCARDED, selected: false, cleared: false },
  { id: 'upload_started', name: 'Started', tlabel: 'MDM_STATUS_UPLOAD_STARTED', query: mdmUploadStatus.UPLOAD_STARTED, selected: false, cleared: false },
  { id: 'upload_in_progress', name: 'In Progress', tlabel: 'MDM_STATUS_UPLOAD_IN_PROGRESS', query: mdmUploadStatus.UPLOAD_IN_PROGRESS, selected: false, cleared: false },
];

export const filterOptionsForApprover = [
  { id: 'approval_pending', name: 'Approval Pending', tlabel: 'MDM_STATUS_APPROVAL_PENDING', query: mdmUploadStatus.APPROVAL_PENDING, selected: false, cleared: false },
  { id: 'approval_rejected', name: 'Approval Rejected', tlabel: 'MDM_STATUS_APPROVAL_REJECTED', query: mdmUploadStatus.APPROVAL_REJECTED, selected: false, cleared: false },
];

export default uploadSampleFileName;
